import { Fragment } from 'react'

import { TFAQ } from '@/entities/support'
import { Separator } from '@/shared/ui'
import { FAQAnswer } from '@/widgets/faq'

import * as Accordion from './accordion'

type Props = {
  faqs: TFAQ[]
}

export const MobileFAQList = ({ faqs }: Props) => {
  return (
    <Accordion.Root type="multiple">
      {faqs.map((faq, index) => (
        <Fragment key={faq.id}>
          <Accordion.Item value={faq.id.toString()} className="space-y-4">
            <Accordion.Trigger className="items-center" strokeWidth={1}>
              <div className="flex flex-1 gap-3">
                <span className="typo-headline1 h-8.5 w-[17px] font-medium text-purple-300">
                  Q
                </span>
                <div className="flex-1 space-y-2 pt-2 text-left">
                  <div className="typo-caption2 font-bold text-gray-400">
                    {faq.categoryName}
                  </div>
                  <p className="typo-body2 font-medium text-gray-900">
                    {faq.question}
                  </p>
                </div>
              </div>
            </Accordion.Trigger>
            <Accordion.Content>
              <div className="bg-gray-0 px-4 py-5">
                <FAQAnswer
                  className="typo-body2-reading whitespace-break-spaces text-gray-900"
                  html={faq.answer}
                />
              </div>
            </Accordion.Content>
          </Accordion.Item>
          {index !== faqs.length - 1 && <Separator className="my-4" />}
        </Fragment>
      ))}
    </Accordion.Root>
  )
}
